module.exports = __webpack_public_path__ + "img/06759a3.webp";